module.exports = __webpack_public_path__ + "img/pablo-mobile-background.77c88043.jpg";